import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const convertToDataTable = (data: IGetUsedBy[]): IGetUsedBy[] => {
  const dataTableData: IGetUsedBy[] = [];

  if(!data) return dataTableData;

  data.map(d => {
    dataTableData.push(d)
  })

  return dataTableData;
}

const getAllUsedByList = async (): Promise<IGetUsedBy[]> => {
  const response =  await axiosDefaultApi.get(`/api/UsedBy/GetUsedBy`);
  return convertToDataTable(response as unknown as IGetUsedBy[]);
};

type QueryFnType = typeof getAllUsedByList;

type UseGetAllUsedByListOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useGetAllUsedByList = ({ config }: UseGetAllUsedByListOptions = {} ) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['getAllUsedByList'],
    queryFn: () => getAllUsedByList(),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση των δεδομένων.`, 500);
      setIsNotificationVisible(true)
    }
  });
};